'use strict';

var SELECTORS = {
    generalErrorContainer: '.error-messaging',
    successMessageContainer: '.success-messaging'
};

var createSuccessNotification = require('friartux/components/successNotification');
var createErrorNotification = require('friartux/components/errorNotification');

/**
 * @description Initializes grpaudit notification display
 */
function init() {
    if (!window.GRPAUDIT_MESSAGE) {
        return;
    }

    var type = window.GRPAUDIT_MESSAGE.type;
    var msg = window.GRPAUDIT_MESSAGE.msg;

    if (type === 'success') {
        createSuccessNotification(
            $(SELECTORS.successMessageContainer),
            msg,
            null,
            true,
            'grpaudit-notification'
        );
    } else {
        createErrorNotification(
            $(SELECTORS.generalErrorContainer),
            msg
        );
    }
}

module.exports = init;
